<template>
    <div>
        <span class="table-sortable"></span>
        <div class="table-cell">
            <user-image :image="rowData.image" :color="rowData.color"></user-image>
            <div class="table-cell-name">
                {{ rowData.name }}
            </div>
        </div>
    </div>
</template>

<script>
import UserImage from '@/components/widgets/UserImageWidget'
export default {
  name: 'EmployeeCell',
  components: {UserImage},
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Employees/EmployeeCell.vue